import { render, staticRenderFns } from "./Catalogos.vue?vue&type=template&id=187b542e"
import script from "./Catalogos.vue?vue&type=script&lang=ts"
export * from "./Catalogos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports